function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { __, path, values } from 'ramda';
import { i18n, MetadataActions, MetadataConstants, MetadataSelectors, SessionSelectors } from 'invision-core';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
import { CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { EwalletErrorSelector, IsRetrievingEwalletDataSelector, PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector, SelectedPaymentMethodSelector, UserHasEWalletAdminAccess } from '../../../../../reducers/selectors/customer.ewallet.selectors';
import { CurrentMemberHasCreatePaymentInstrumentPermissionsSelector } from './../../../../../reducers/selectors/customer.household.selectors';
import { CurrencySelector, CurrentRemovalSelector, CurrentSubscriptionIdSelector, RemoveSubscriptionNameSelector, CurrentSubscriptionSelector, IsFetchingDataSelector, IsRemovingSubscriptionSelector, RemoveChildSubscriptionSelector, SubscriptionErrorSelector, UserCanIssueCreditToAlternatePaymentInstrument } from '../../../../../reducers/selectors/customer.subscriptions.selectors';
import { SubscriptionWithDetailedItemsSelector } from '../../../../../reducers/selectors/customer.subscriptions.products.selectors';
import { calculateRemoveOrderQuote, removeSubscription, retrieveSubscription, setIncludedFilter } from '../../../../../reducers/actions/customer.subscriptions.actions';
import { retrieveWallet, selectPaymentMethod } from '../../../../../reducers/actions/customer.ewallet.actions';
import * as SubscriptionConstants from '../../../../shared/constants/subscriptions.constants';
import { SUBSCRIPTION_LIST_ROUTE } from '../../../../../reducers/constants/dashboard.constants';
var RemoveSubscriptionController = /*#__PURE__*/function () {
  function RemoveSubscriptionController($ngRedux, $state, $q, $filter, uiNotificationService) {
    var _this = this;
    _classCallCheck(this, RemoveSubscriptionController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $q: $q,
      $filter: $filter,
      uiNotificationService: uiNotificationService,
      CustomerCareLocaleKeys: CustomerCareLocaleKeys
    });
    this.metadataCodes = [MetadataConstants.codes.SubscriptionTerminationReason, MetadataConstants.codes.CreditReasons, MetadataConstants.codes.WaiveFeeReason];
    this.confirmationPopup = {
      onRegisterApi: function onRegisterApi(_ref) {
        var api = _ref.api;
        _this.confirmationPopup.api = api;
      }
    };
    this.removal = {
      sendNotification: true,
      terminationReason: null,
      creditReason: null,
      waiveFeeReason: null,
      itemCredits: []
    };
    this.terminationFeeTooltip = require('./remove.subscription.tooltip.html');

    // Necessary for child component callback
    this.onConfirmation = this.onConfirmation.bind(this);
  }
  return _createClass(RemoveSubscriptionController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        var selectOptions = MetadataSelectors.codes.MetadataOptionsForCodeValuesSelector(__, store);
        return {
          canIssueCreditToAlternatePaymentMethod: UserCanIssueCreditToAlternatePaymentInstrument(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          currentMemberCanCreatePaymentInstrument: CurrentMemberHasCreatePaymentInstrumentPermissionsSelector(store),
          currency: CurrencySelector(store),
          currentRemoval: CurrentRemovalSelector(store),
          currentSubscription: CurrentSubscriptionSelector(store),
          removeSubscription: RemoveChildSubscriptionSelector(store),
          currentSubscriptionItems: SubscriptionWithDetailedItemsSelector(store),
          eWalletError: EwalletErrorSelector(store),
          isFetchingData: IsFetchingDataSelector(store),
          isFetchingEwalletData: IsRetrievingEwalletDataSelector(store),
          isRemovingSubscription: IsRemovingSubscriptionSelector(store),
          lastRoute: SessionSelectors.LastRouteSelector(store),
          subscriptionId: CurrentSubscriptionIdSelector(store),
          subscriptionName: RemoveSubscriptionNameSelector(store),
          subscriptionError: SubscriptionErrorSelector(store),
          codeTypeLoaded: MetadataSelectors.codes.MetadataCodeLoadedSelector(__, store),
          creditReasons: selectOptions(MetadataConstants.codes.CreditReasons),
          paymentInstruments: PaymentInstrumentsCanBeUsedForOrderingWithTypeNamesViewModelSelector(store),
          selectedPaymentMethod: SelectedPaymentMethodSelector(store),
          subscriptionTerminationReasons: selectOptions(MetadataConstants.codes.SubscriptionTerminationReason),
          userHasEWalletAdminAccess: UserHasEWalletAdminAccess(store),
          waiveFeeReasons: selectOptions(MetadataConstants.codes.WaiveFeeReason)
        };
      };
      var controllerActions = {
        calculateRemoveOrderQuote: calculateRemoveOrderQuote,
        fetchCodeType: MetadataActions.codes.fetchCodeTypes,
        removeSubscription: removeSubscription,
        retrieveSubscription: retrieveSubscription,
        retrieveWallet: retrieveWallet,
        setIncludedFilter: setIncludedFilter,
        selectPaymentMethod: selectPaymentMethod
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this2.state = state;
        _this2.actions = actions;
      });
      this.metadataCodes.forEach(function (code) {
        if (!_this2.state.codeTypeLoaded(code)) {
          _this2.actions.fetchCodeType(code);
        }
      });
      this.$q.all([this.actions.retrieveSubscription(this.state.currentCustomerId, {
        Id: this.state.subscriptionId
      }), this.actions.retrieveWallet({
        customerId: this.state.currentCustomerId
      })]).then(function () {
        var removalQuoteRequest = {
          subscriptionId: _this2.state.subscriptionId,
          immediateRemove: _this2.state.currentSubscription.Policy.ImmediateRemoveAllowed
        };
        if (_this2.state.removeSubscription) {
          removalQuoteRequest.removeItemIds = [_this2.state.removeSubscription.Id];
        }
        return _this2.actions.calculateRemoveOrderQuote(_this2.state.currentCustomerId, removalQuoteRequest);
      }).then(function () {
        return _this2.actions.selectPaymentMethod(_this2.state.currentSubscription.PaymentInstrument);
      }).catch(function () {
        var message = path(['eWalletError', 'message'], _this2.state) || path(['subscriptionError', 'message'], _this2.state);
        if (message) {
          _this2.uiNotificationService.transientError(message);
        }
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "removeSubscription",
    value: function removeSubscription() {
      var _this3 = this;
      var creditItems = [];
      var removalKeys = Object.keys(this.removal.itemCredits);
      var itemCreditTotal = 0;
      removalKeys.forEach(function (itemKey) {
        var creditAmount = _this3.removal.itemCredits[itemKey];
        if (creditAmount > 0) {
          itemCreditTotal += creditAmount;
          creditItems.push({
            amount: creditAmount,
            subscriptionItemId: itemKey
          });
        }
      });
      var hasCredit = false;
      if (this.removal.applyTotalCredit) {
        if (this.appliedCredit > 0) {
          hasCredit = true;
        }
      } else {
        if (itemCreditTotal > 0) {
          hasCredit = true;
        }
      }
      var removeSubscriptionRequest = {
        sendNotification: this.removal.sendNotification,
        removeReasonCode: this.removal.terminationReason,
        waiveTerminationFee: this.removal.waiveTerminationFee,
        waiveTerminationFeeReason: this.removal.waiveFeeReason,
        creditAmount: this.removal.applyTotalCredit ? this.appliedCredit : 0,
        creditItems: !this.removal.applyTotalCredit ? creditItems : null,
        creditReason: this.removal.creditReason
      };
      if (hasCredit && (!this.state.selectedPaymentMethod || this.state.selectedPaymentMethod.Status !== SubscriptionConstants.PAYMENT_METHOD_STATUSES.ACTIVE)) {
        this.uiNotificationService.error(i18n.translate(CustomerCareLocaleKeys.SUBSCRIPTIONS.REMOVE_SUBSCRIPTION.PAYMENT_REQUIRED), null);
        return;
      }
      if (this.state.selectedPaymentMethod && this.state.selectedPaymentMethod.Status === SubscriptionConstants.PAYMENT_METHOD_STATUSES.ACTIVE) {
        removeSubscriptionRequest.paymentInstrumentIds = this.state.selectedPaymentMethod ? [this.state.selectedPaymentMethod.Id] : null;
      }
      if (hasCredit) {
        // Set to null to use original payment method for credit payment
        removeSubscriptionRequest.creditPaymentInstrumentId = null;
      }
      if (this.state.removeSubscription) {
        removeSubscriptionRequest.removeItemIds = [this.state.removeSubscription.Id];
      } else {
        removeSubscriptionRequest.subscriptionId = this.state.subscriptionId;
      }
      this.actions.removeSubscription(this.state.currentCustomerId, removeSubscriptionRequest).then(function () {
        _this3.uiNotificationService.transientSuccess(i18n.translate(CustomerCareLocaleKeys.SUBSCRIPTIONS.REMOVE_SUBSCRIPTION.SUCCESS));
        _this3.removeSubscriptionForm.$setPristine();
        _this3.actions.setIncludedFilter(true);
        _this3.$state.go(SUBSCRIPTION_LIST_ROUTE);
      }).catch(function () {
        if (_this3.state.subscriptionError) {
          _this3.uiNotificationService.transientError(_this3.state.subscriptionError.message);
        }
      });
    }
  }, {
    key: "isCurrentPaymentMethodRemoved",
    value: function isCurrentPaymentMethodRemoved() {
      if (!this.state.selectedPaymentMethod) {
        return false;
      }
      return this.state.selectedPaymentMethod.Status === SubscriptionConstants.PAYMENT_METHOD_STATUSES.REMOVED;
    }
  }, {
    key: "confirmRemoval",
    value: function confirmRemoval() {
      if (this.removeSubscriptionForm.$valid) {
        this.confirmationPopup.api.open();
      }
    }
  }, {
    key: "onConfirmation",
    value: function onConfirmation(confirmed) {
      if (confirmed) {
        this.removeSubscription();
      }
      this.confirmationPopup.api.close();
    }
  }, {
    key: "appliedCredit",
    get: function get() {
      return this.removal.applyTotalCredit ? this.state.currentRemoval.totalRemainingAmount : values(this.removal.itemCredits).reduce(function (total, value) {
        return total += value || 0;
      }, 0);
    }
  }, {
    key: "appliedTerminationFee",
    get: function get() {
      return this.removal.waiveTerminationFee || !this.state.currentRemoval.quote ? 0 : this.state.currentRemoval.quote.totals.totalAmount;
    }
  }, {
    key: "canCreatePaymentInstruments",
    get: function get() {
      return this.state.currentMemberCanCreatePaymentInstrument && this.state.userHasEWalletAdminAccess;
    }
  }, {
    key: "isLoading",
    get: function get() {
      var _this4 = this;
      return this.state.isFetchingData || this.state.isFetchingEwalletData || this.state.isRemovingSubscription || this.metadataCodes.some(function (code) {
        return !_this4.state.codeTypeLoaded(code);
      });
    }
  }, {
    key: "formattedRemainingAmount",
    get: function get() {
      return this.$filter('invCurrency')(this.state.currentRemoval.totalRemainingAmount, this.state.currency);
    }
  }]);
}();
export default {
  bindings: {},
  template: require('./remove.subscription.html'),
  controller: RemoveSubscriptionController,
  controllerAs: 'removeSubscriptionController'
};